module.exports = __webpack_public_path__ + "img/profile_matsuta.906b7714.jpg";